import styled from 'styled-components';

export const Footer = styled.div`
  background: #004f92;
`;

export const Container = styled.div`
  width: 100%;
  padding-right: 32px;
  padding-left: 32px;
  margin-right: auto;
  margin-left: auto;

  @media (min-width: 576px) {
    width: 540px;
  }

  @media (min-width: 768px) {
    width: 720px;
  }

  @media (min-width: 992px) {
    width: 960px;
  }

  @media (min-width: 1200px) {
    width: 1140px;
  }
`;

export const HeadFooter = styled.div`
  background: #009ddc;
  padding: 12px 30px;

  p {
    font-family: 'Montserrat', sans-serif;
    font-size: 18px;
    font-weight: 500;
    line-height: 26px;
    letter-spacing: 0;
    text-align: center;
    color: #ffffff;
  }

  @media (max-width: 900px) {
    p {
      font-size: 14px;
      line-height: 22px;
    }
  }
`;

export const BodyFooter = styled.div`
  display: grid;
  grid-template-columns: 30% 40% 30%;
  justify-content: space-between;

  padding: 48px 0;

  @media (max-width: 900px) {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 32px;
  }
`;

export const SupportContainer = styled.div`
  a {
    font-family: 'Montserrat', sans-serif;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: 0;
    text-decoration: none;
    color: #ffffff;
  }

  p {
    font-family: 'Montserrat', sans-serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 22px;
    letter-spacing: 0;
    color: #ffffff;

    width: 245px;
    margin-top: 14px;
  }
`;

export const TalkContainer = styled.div`
  a {
    font-family: 'Montserrat', sans-serif;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: 0;
    text-decoration: none;
    color: #ffffff;
  }
`;

export const SocialContainer = styled.div`
  a {
    text-decoration: none;

    img {
      width: 32px;
      height: 32px;
    }
  }

  @media (max-width: 900px) {
    padding-top: 16px;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const Title = styled.h1`
  font-family: 'Montserrat', sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0;
  color: #ffffff;

  margin-bottom: 8px;
`;

export const CopyContainer = styled.div`
  display: grid;
  grid-template-columns: 50% 50%;
  justify-content: space-between;

  padding-top: 24px;
  padding-bottom: 48px;
  border-top: 1px solid #ffffff;

  @media (max-width: 900px) {
    padding-top: 16px;
    grid-template-columns: 100%;
  }
`;

export const TextCopyright = styled.p`
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: 0;
  color: #ffffff;

  @media (max-width: 900px) {
    font-size: 12px;
  }
`;

export const TextPolicesAndTerms = styled.a`
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: 0;
  text-align: right;
  text-decoration: none;
  cursor: pointer;
  color: #ffffff;

  @media (max-width: 900px) {
    font-size: 12px;
    text-align: left;

    margin-top: 16px;
  }
`;
